import { useState, useCallback, useEffect } from 'react';

export const useQuestionAnswers = (serviceCategories, selectedCatId, selectedSubcatId, selectedServiceId) => {
    const [answers, setAnswers] = useState([]);
    const [answersComplete, setAnswersComplete] = useState(false);

    const handleAnswer = useCallback((event, questionId, answerType, answerId) => {
        setAnswers(prevAnswers => {
            let newAnswers = [...prevAnswers];
            
            if (answerType === "radio") {
                newAnswers = newAnswers.filter(x => x.questionId !== questionId);
                newAnswers.push({
                    questionId: questionId,
                    answers: [answerId]
                });
            } else if (answerType === "check") {
                const existingAnswer = newAnswers.find(x => x.questionId === questionId);
                
                if (existingAnswer) {
                    if (event.target.checked) {
                        existingAnswer.answers.push(answerId);
                    } else {
                        existingAnswer.answers = existingAnswer.answers.filter(y => y !== answerId);
                    }
                    newAnswers = newAnswers.filter(x => x.answers.length > 0);
                } else {
                    newAnswers.push({
                        questionId: questionId,
                        answers: [answerId]
                    });
                }
            }
            
            return newAnswers;
        });
    }, []);

    useEffect(() => {
        const selectedService = serviceCategories
            ?.find(x => x.id === parseInt(selectedCatId))
            ?.serviceSubCategories?.find(x => x.id === parseInt(selectedSubcatId))
            ?.services?.find(x => x.id === parseInt(selectedServiceId));
        
        if (!selectedService?.serviceQuestions) {
            setAnswersComplete(true);
            return;
        }

        const allAnswered = selectedService.serviceQuestions.every(
            question => answers.some(answer => answer.questionId === question.questionId)
        );
        
        setAnswersComplete(allAnswered);
    }, [answers, serviceCategories, selectedCatId, selectedSubcatId, selectedServiceId]);

    const resetAnswers = useCallback(() => {
        setAnswers([]);
        setAnswersComplete(false);
    }, []);

    return {
        answers,
        answersComplete,
        handleAnswer,
        resetAnswers,
        setAnswers
    };
};
